var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.94 0.92 28.13 27.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 15.7342C19.1344 15.7342 22.5 12.4135 22.5 8.33424C22.5 4.25499 19.1344 0.924988 15 0.924988C10.8656 0.924988 7.5 4.24574 7.5 8.32499C7.5 12.4042 10.8656 15.725 15 15.725V15.7342ZM15 2.77499C18.1031 2.77499 20.625 5.26324 20.625 8.32499C20.625 11.3867 18.1031 13.875 15 13.875C11.8969 13.875 9.375 11.3867 9.375 8.32499C9.375 5.26324 11.8969 2.77499 15 2.77499Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7594 17.5657H11.2406C5.55937 17.5657 0.9375 22.126 0.9375 27.7315V28.6657H29.0625V27.7315C29.0625 22.126 24.4406 17.5657 18.7594 17.5657ZM2.85938 26.825C3.31875 22.6625 6.9 19.425 11.2406 19.425H18.7594C23.0906 19.425 26.6719 22.6625 27.1313 26.825H2.85938Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.4adbf50edabcdb195fcf006a0191b194.svg";
export { ForwardRef as ReactComponent };